module.exports = __webpack_public_path__ + "static/media/step-by-step-welcome-banner.0cfbd610.webp";